<template>
  <div
    class="card-degree-text p-space-xs p-lg-space-sm border"
    :class="cardClass"
    :style="cardStyle">
    <div class="card-degree-text-body">
      <p v-if="showLabel">
        <span
          class="mb-space-xs cdt-label fw-bold"
          :class="labelClass"
          v-html="label"></span>
      </p>
      <h3 class="mb-space-xs fw-bold" :class="titleClass" v-html="title"></h3>
      <hr class="card-degree-text-underline" :style="underlineStyle" />
      <div v-if="iconDescription" class="mb-space-xxs">
        <div class="d-flex justify-content-start align-items-start">
          <font-awesome-icon
            :icon="faChartLine"
            class="fs-xs"
            role="presentation"></font-awesome-icon>
          <div
            class="fs-xs ps-space-xxs mb-space-xxs mt-n1"
            v-html="growthDescription"></div>
        </div>
        <div class="d-flex justify-content-start align-items-start">
          <font-awesome-icon
            :icon="faDollarSign"
            class="fs-xs"
            role="presentation"></font-awesome-icon>
          <font-awesome-icon
            :icon="faDollarSign"
            class="fs-xs"
            role="presentation"></font-awesome-icon>
          <div
            class="fs-xs mb-space-xxs ps-space-xxs mt-n1"
            v-html="salaryDescription"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { faChartLine, faDollarSign } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";

interface Props {
  borderVariant?: string;
  showLabel?: boolean;
  label?: string;
  labelSize?: "xs" | "small" | "medium" | "large" | "xl" | "xxl";
  labelVariant?: string;
  labelBackgroundVariant?: string;
  title: string;
  titleSize?: "small" | "medium" | "large" | "xl";
  titleVariant?: string;
  underlineColor?: string;
  highlightColor?: string;
  iconDescription?: boolean;
  growthDescription?: string;
  salaryDescription?: string;
  bgVariant?: string;
}

const props = withDefaults(defineProps<Props>(), {
  borderVariant: "light-4",
  showLabel: true,
  label: "Lorem Ipsum",
  labelSize: "xs",
  labelVariant: "white",
  labelBackgroundVariant: "dark-3",
  titleSize: "medium",
  titleVariant: "dark-3",
  underlineColor: "var( --rds-secondary, #ffc627)",
  highlightColor: "var( --rds-secondary, #ffc627)",
  iconDescription: false,
  growthDescription: "Lorem ipsum",
  salaryDescription: "Lorem ipsum",
  bgVariant: "white",
});

const cardClass = computed(() => {
  return `border-${props.borderVariant} bg-${props.bgVariant}`;
});

const cardStyle = computed(() => {
  return {
    "border-bottom": `7px solid ${getColor(props.highlightColor)} !important`,
  };
});

const labelClass = computed(() => {
  return `fs-${props.labelSize} text-${props.labelVariant} bg-${props.labelBackgroundVariant}`;
});

const titleClass = computed(() => {
  return `h3-${props.titleSize} text-${props.titleVariant}`;
});

const underlineStyle = computed(() => {
  return {
    "background-color": getColor(props.underlineColor),
  };
});

const getColor = (color: string) => {
  if (color.includes("var(")) {
    return `${color}`;
  } else if (color.includes("--")) {
    return `var(${color})`;
  } else {
    return color;
  }
};
</script>

<style lang="scss" scoped>
.card-degree-text {
  min-height: 135px;
}
.card-degree-text-underline {
  height: 2px;
  width: 14%;
  margin-top: 0;
  display: inline-block;
  border-top: none;
}
.mt-n1 {
  margin-top: -1px !important;
}
.cdt-label {
  padding: 4px;
}
</style>
